import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import { toast } from 'react-toastify';
import EditProfile from '../EditProfile';
import StudentWrapper from '../StudentWrapper';
import Input from '../../components/Input';

const StudentSettings = () => {
  const [teachers, setTeachers] = useState([]);
  const [loading, setLoading] = useState(false);

  const [socials, setSocials] = useState({});
  const [name, setName] = useState('Admin');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [getProfile, setGetProfile] = useState({});
  useEffect(() => {
    const storedAdminData = localStorage.getItem('userData');
    if (storedAdminData) {
      const admin = JSON.parse(storedAdminData);
      setGetProfile(admin);
      setName(admin?.name || 'Admin');
      setEmail(admin?.email);
      setPhone(admin?.phoneNumber);
    } else {
      console.log('No admin data found in local storage.');
    }
  }, []);

  const fetchCategory = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true);
    fetch('https://quran-backend-theta.vercel.app/v1/admin/category', requestOptions)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setTeachers(data?.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategory();

    const requestOptions2 = {
      method: 'GET',
      redirect: 'follow'
    };

    setLoading(true);
    fetch('https://quran-backend-theta.vercel.app/v1/admin/socialLinks', requestOptions2)
      .then((response) => response.text())
      .then((result) => {
        let data = JSON.parse(result);
        setSocials(data?.data?.[0]);
        setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        setLoading(false);
      });
  }, []);

  const [isModalOpen, setIsModalOpen] = useState(false);

  const CloseModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const CloseEditModal = () => {
    setIsEditModalOpen(!isModalOpen);
  };

  const [isSocialModal, setIsSocialModal] = useState(false);

  const CloseSocialModal = () => {
    setIsSocialModal(!isSocialModal);
  };
  const [socialData, setSocialData] = useState('');
  const [getData, setGetData] = useState({});

  console.log(getProfile);

  const handleDeleteBanner = (id) => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        deleteBanner(id);
      }
    });
  };

  const deleteBanner = async (id) => {
    const requestOptions = {
      method: 'DELETE',
      redirect: 'follow'
    };

    try {
      const response = await fetch(
        `https://quran-backend-theta.vercel.app/v1/admin/category/${id}`,
        requestOptions
      );
      const result = await response.text();
      let data = JSON.parse(result);

      if (data?.success === true) {
        toast.success('Category deleted successfully!');
        fetchCategory();
      } else {
        toast.error('Failed to delete banner');
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while deleting the banner');
    }
  };

  return (
    <StudentWrapper
      searchBar={
        <Input
          placeholder={`Search...`}
          Icon={
            <img src={require('../../assets/image/Search-Magnifier.png')} className=" w-8" alt="" />
          }
          className={' w-full bg-white  pl-12'}
        />
      }
    >
      <EditProfile
        getData={getProfile}
        setIsModalOpen={setIsEditModalOpen}
        closeModal={CloseEditModal}
        isModalOpen={isEditModalOpen}
      />
      <div className="flex justify-between items-center ">
        <div>
          <h2 className="main_title ">Settings</h2>
          <p className="text-[#1C1D1D]">Here overview of the settings</p>
        </div>
      </div>

      <div className="  mt-4 bg-[#FAFAFA] w-full p-4  rounded-lg">
        <div className=" flex justify-between items-center">
          <h6 className="text-[#1C1D1D]  text-xl font-semibold">Profile Details</h6>
          <button
            onClick={() => {
              setIsEditModalOpen(true);
            }}
            className=" underline text-lg"
          >
            Edit Profile
          </button>
        </div>
        <div className=" w-24 h-24 rounded-full mt-4">
          <img src={getProfile?.photo} className=" w-full h-full rounded-full" alt="" />
        </div>
        <ul className=" sm:w-96  w-full mt-4">
          <li className=" flex justify-between items-center py-2">
            <p className=" text-[#1C1C1C66]">First Name</p>
            <p className=" text-[#1C1C1C] text-lg">{name}</p>
          </li>
          <li className=" flex justify-between items-center py-2">
            <p className=" text-[#1C1C1C66]">Last Name</p>
            <p className=" text-[#1C1C1C] text-lg">Admin</p>
          </li>
          <li className=" flex justify-between items-center py-2">
            <p className=" text-[#1C1C1C66]">Contact Number</p>
            <p className=" text-[#1C1C1C] text-lg">{phone}</p>
          </li>
          <li className=" flex justify-between items-center py-2">
            <p className=" text-[#1C1C1C66]">Email Address</p>
            <p className=" text-[#1C1C1C] text-lg">{email}</p>
          </li>
        </ul>
      </div>
    </StudentWrapper>
  );
};

export default StudentSettings;
